// extracted by mini-css-extract-plugin
export default {"calendar-controls__tooltip-text":"calendar-controls__tooltip-text--E0Z3H","calendarControlsTooltipText":"calendar-controls__tooltip-text--E0Z3H"};